/**
 * Returns the canonical site origin (e.g. "https://avianayoga.com").
 *
 * Why: Holly is sometimes signed in via the platform's `*.emergent.host` URL
 * (because that's what email login links use). When she copies a "share with
 * your students" link from the dashboard, she shouldn't accidentally hand out
 * a `retreat-hub-12.emergent.host/...` link — it should always be the public
 * avianayoga.com URL.
 *
 * Build-time env var REACT_APP_CANONICAL_URL is the source of truth.
 * Falls back to REACT_APP_BACKEND_URL or window.location.origin so dev still
 * works.
 */
export function canonicalOrigin() {
  const env = (process.env.REACT_APP_CANONICAL_URL || process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  if (env) return env;
  if (typeof window !== "undefined") return window.location.origin.replace(/\/+$/, "");
  return "";
}

/** Build a fully-qualified URL on the canonical domain. */
export function canonicalUrl(path = "/") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${canonicalOrigin()}${p}`;
}
